import { EventBus } from '../../helpers';

type UpdateBillingEvents = {
  requestUpdateInfo: [];
  requestExitForm: [];
};

class UpdateBillingEventBus extends EventBus<UpdateBillingEvents> {}

export const updateBillingEventBus = new UpdateBillingEventBus();
